export default "__VITE_ASSET__jtr7rD3Y__"